import { lib } from '@giscube/geoportal'
const { GiscubeRef } = lib.refs

export const baseOverlayId = new GiscubeRef('40.14')
export const baseGrayOverlayId = new GiscubeRef('40.15')

export const panoramasLayer = {
  id: new GiscubeRef('23.1'),
  layerDescriptor: {
    group: false,
    projection: '4326',
    title: 'Panorames 2018',
    type: 'WMS',
    url: 'https://geoportal.reus.cat/apps/giscube-admin/qgisserver/services/moma-panorames-2018',
    layers: 'panorames_2018'
  },
  options: {
    interactive: false
  },
  title: 'Punts de Mobile Mapping',
  auth: true
}

export const cadastreLayer = {
  id: new lib.refs.GiscubeRef('6.3'),
  layerDescriptor: {
    group: false,
    projection: '4326',
    title: 'Cadastre DGC',
    type: 'WMS',
    url: 'https://ovc.catastro.meh.es/Cartografia/WMS/ServidorWMS.aspx',
    layers: 'catastro'
  },
  options: {
    interactive: false
  },
  title: 'Cadastre DGC'
}
